import React from 'react';

function Footer(){
    return (
        <footer className='bt100 bg-light'>
           
        </footer>
    )
}

export default Footer;